import useMutationCall from "../../../hooks/useMutationCall";
import { usePostProjectStatusMutation } from "../projectsSlice";

const useProjectStatusPost = () => {
  return useMutationCall(usePostProjectStatusMutation);
};

export default useProjectStatusPost;